var React = require('react');

function LocationOn24px (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mijn werkadres: Travertijstraat 12, 9743 Groningen"),React.createElement("desc",{"key":1},"Een icoon dat werkt als link naar mijn de google maps pagina van mijn werkadres"),React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":2}),React.createElement("path",{"d":"M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z","key":3})]);
}

LocationOn24px.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = LocationOn24px;

LocationOn24px.default = LocationOn24px;
